import axios from "axios";
import React, { useEffect, useState } from "react";
import { ApiConnectionString } from "../../constants/ApiConntection";
import { useParams, useLocation } from "react-router-dom";
import "./WidgitTimetable.css";

export default function WidgitTimetable() {
  const [events, setEvents] = useState([]);
  const { id } = useParams();
  const location = useLocation();

  const [settings, setSettings] = useState({
    buttonColour: "#007bff",
    buttonTextColour: "#007bff",
    buttonBackgroundColour: "#ffffff",
    buttonHoverBackgroundColour: "#0056b3",
    buttonHoverTextColour: "#ffffff",
    buttonShape: "rounded",
    buttonStyle: "outline",
    tableHeaderColour: "#f8f9fa",
    tableBodyColour: "#ffffff",
    tableBorderColour: "#ffffff",
    innerBoxBorderColour: "#cccccc",
    innerBoxBackgroundColour: "#ffffff",
    dayFontColour: "#000000",
    dateFontColour: "#000000",
    font: "Arial",
    corners: "rounded",
    textColour: "#000000",
    backgroundColour: "#ffffff",
    timeFormat: "12-hour",
  });

  const [currentDateTime, setCurrentDateTime] = useState(new Date());
  const [dates, setDates] = useState({});
  const [days, setDays] = useState({});
  const [showPastDays, setShowPastDays] = useState(false);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    setSettings({
      buttonColour: params.get("buttonColour") || "#007bff",
      buttonTextColour: params.get("buttonTextColour") || "#007bff",
      buttonBackgroundColour: params.get("buttonBackgroundColour") || "#ffffff",
      buttonHoverBackgroundColour:
        params.get("buttonHoverBackgroundColour") || "#0056b3",
      buttonHoverTextColour:
        params.get("buttonHoverTextColour") || "#ffffff",
      buttonShape: params.get("buttonShape") || "rounded",
      buttonStyle: params.get("buttonStyle") || "outline",
      tableHeaderColour: params.get("tableHeaderColour") || "#f8f9fa",
      tableBodyColour: params.get("tableBodyColour") || "#ffffff",
      tableBorderColour: params.get("tableBorderColour") || "#ffffff",
      innerBoxBorderColour: params.get("innerBoxBorderColour") || "#cccccc",
      innerBoxBackgroundColour:
        params.get("innerBoxBackgroundColour") || "#ffffff",
      dayFontColour: params.get("dayFontColour") || "#000000",
      dateFontColour: params.get("dateFontColour") || "#000000",
      font: params.get("font") || "Arial",
      corners: params.get("corners") || "rounded",
      textColour: params.get("textColour") || "#000000",
      backgroundColour: params.get("backgroundColour") || "#ffffff",
      timeFormat: params.get("timeFormat") || "12-hour",
    });
  }, [location.search]);

  const getDateTime = () => {
    const now = currentDateTime;
    const y = now.getFullYear();
    const m = String(now.getMonth() + 1).padStart(2, "0");
    const d = String(now.getDate()).padStart(2, "0");
    return `${y}-${m}-${d}`;
  };

  const addOneWeek = () =>
    setCurrentDateTime((prev) => {
      const n = new Date(prev);
      n.setDate(n.getDate() + 7);
      return n;
    });

  const minusOneWeek = () => {
    setShowPastDays(true);
    setCurrentDateTime((prev) => {
      const n = new Date(prev);
      n.setDate(n.getDate() - 7);
      return n;
    });
  };

  useEffect(() => {
    if (events && events.length > 0) {
      const order = [
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday",
        "Sunday",
      ];
      const map = {};
      order.forEach((day) => {
        map[day] = events
          .filter((e) => e.day === day)
          .sort((a, b) => a.timeIn - b.timeIn);
      });
      setDays(map);
    }
  }, [events]);

  const fetchData = async () => {
    try {
      const res = await axios.get(
        `${ApiConnectionString}/api/events?ClubId=${id}&FromDateTime=${getDateTime()}`
      );
      setEvents(res.data);
      console.log( `${ApiConnectionString}/api/events?ClubId=${id}&FromDateTime=${getDateTime()}`)
    } catch (err) {
      console.error("Error fetching events:", err);
    }
  };

  useEffect(() => {
    const weekStart = new Date(currentDateTime);
    const diffToMonday =
      (weekStart.getDay() === 0 ? -6 : 1) - weekStart.getDay();
    weekStart.setDate(weekStart.getDate() + diffToMonday);
    const week = Array.from({ length: 7 }, (_, i) => {
      const d = new Date(weekStart);
      d.setDate(weekStart.getDate() + i);
      return d;
    });
    setDates({
      Monday: week[0],
      Tuesday: week[1],
      Wednesday: week[2],
      Thursday: week[3],
      Friday: week[4],
      Saturday: week[5],
      Sunday: week[6],
    });
    fetchData();
  }, [currentDateTime, id]);

  const formatTime = (t) => {
    const h24 = Math.floor(t / 100);
    const m = t % 100;
    if (settings.timeFormat === "24-hour")
      return `${String(h24).padStart(2, "0")}:${String(m).padStart(2, "0")}`;
    const ampm = h24 >= 12 ? "pm" : "am";
    const h12 = h24 % 12 === 0 ? 12 : h24 % 12;
    const mStr = m === 0 ? "" : `:${String(m).padStart(2, "0")}`;
    return `${h12}${mStr}${ampm}`;
  };

  const goTopLevel = (url) => {
    try {
      if (window.top && window.top !== window.self) {
        window.top.location.href = url;
        return;
      }
    } catch {}
    window.location.href = url;
  };

  const handleBook = (activity, day) => {
    const d = dates[day];
    if (!d) return;
    const date = d.toISOString().slice(0, 10);
    goTopLevel(`/embeddedbooking/${id}/${activity.id}/${date}`);
  };

  return (
    <div
      className="timetable-wrapper"
      style={{
        fontFamily: settings.font,
        backgroundColor: settings.backgroundColour,
        color: settings.textColour,
      }}
    >
      <div className="timetable-top container">
        <div className="timetable-nav">
          <button onClick={minusOneWeek}>
            <p style={{ fontFamily: settings.font }}>&lt; Previous</p>
          </button>
          <button onClick={addOneWeek}>
            <p style={{ fontFamily: settings.font }}>Next &gt;</p>
          </button>
        </div>
      </div>

      <div className="timetable-grid">
        {Object.keys(dates).map((day) => {
          const items = days[day] || [];
          if (items.length === 0) return null;

          return (
            <div
              key={day}
              className={`timetable-day ${
                settings.corners === "rounded" ? "rounded" : ""
              }`}
              style={{
                backgroundColor: settings.tableBodyColour,
                border: `1px solid ${settings.tableBorderColour}`,
              }}
            >
              <div
                className="timetable-day-header"
                style={{
                  backgroundColor: settings.tableHeaderColour,
                  borderBottom: `1px solid ${settings.tableBorderColour}`,
                }}
              >
                <div className="d-flex justify-content-between">    <p
                  className="day-name m-0"
                  style={{ color: settings.dayFontColour, fontFamily: settings.font }}
                >
                  {day}
                </p>
                <p
                  className="day-date m-0"
                  style={{ color: settings.dateFontColour, fontFamily: settings.font }}
                >
                  {dates[day]?.toLocaleDateString() || ""}
                </p></div>
            
              </div>

              <div className="timetable-day-body">
                {items.map((activity) => {
                  const isSolid = settings.buttonStyle === "solid";
                  const shapeClass =
                    settings.buttonShape === "rounded" ? "rounded" : "square";

                  return (
                    <div
                      key={activity.id}
                      className="timetable-item"
                      style={{
                        backgroundColor: settings.innerBoxBackgroundColour,
                        border: `1px solid ${settings.innerBoxBorderColour}`,
                      }}
                    >
                      <p className="item-name" style={{ fontFamily: settings.font }}>
                        {activity.name}
                      </p>
                      <p className="item-time" style={{ fontFamily: settings.font }}>
                        {formatTime(activity.timeIn)} to {formatTime(activity.timeOut)}
                      </p>

                      <button
                        className={`book-btn ${shapeClass}`}
                        style={{
                          borderColor: settings.buttonColour,
                          color: isSolid
                            ? settings.buttonTextColour
                            : settings.buttonColour,
                          backgroundColor: isSolid
                            ? settings.buttonBackgroundColour
                            : "transparent",
                          transition: "all 0.2s ease",
                          fontFamily: settings.font,
                        }}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.backgroundColor =
                            settings.buttonHoverBackgroundColour;
                          e.currentTarget.style.color =
                            settings.buttonHoverTextColour;
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.backgroundColor = isSolid
                            ? settings.buttonBackgroundColour
                            : "transparent";
                          e.currentTarget.style.color = isSolid
                            ? settings.buttonTextColour
                            : settings.buttonColour;
                        }}
                        disabled={activity.bookingCapacity === activity.bookedCount}
                        onClick={() => handleBook(activity, day)}
                      >
                        <p className="my-0 mx-2"  style={{ fontFamily: settings.font }}>
                          {activity.bookingCapacity === activity.bookedCount
                            ? "Fully booked"
                            : activity.booked
                            ? "Book more"
                            : "Book now"}
                        </p>
                      </button>
                    </div>
                  );
                })}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
